export interface IArtifactExportColumn {
  id: string
  name: string
  type?: string
  description?: string
}

export interface IArtifactExportShapefile {
  id: string
  name: string
  displayName: string
  iconKey: string
  colorKey: string
  visible?: boolean
  disabled?: boolean
  defaultSelected?: boolean
  columns: IArtifactExportColumn[]
}

export interface IArtifactExportFolder {
  id: string
  name: string
  displayName: string
  description: string
  iconKey: string
  colorKey: string
  visible?: boolean
  disabled?: boolean
  defaultSelected?: boolean
}

export interface IArtifactExportFormat {
  value: string
  label: string
  description: string
  iconKey?: string
  defaultSelected?: boolean
}

export interface IArtifactExportSection {
  id: string
  displayName: string
  shapefiles: IArtifactExportShapefile[]
  folders: IArtifactExportFolder[]
  formats: IArtifactExportFormat[]
}

export type ArtifactExportFlagValue = string | number | boolean | null | undefined

function handleStringToObj(str: any, defaultVal: any) {
  if (!str) return defaultVal
  try {
    return JSON.parse(str)
  } catch (e) {
    console.error('Failed while parsing the data')
    return defaultVal
  }
}

const playAudioFile = (pathToFile: string) => {
  const audio = new Audio(pathToFile)
  audio.crossOrigin = 'anonymous'
  audio.play()
}


export const parseImageryProcurementClients = (clientEnvVarsString: any): string[] => {
  try {
    let rawConfig: any[] = []

    if (typeof clientEnvVarsString === 'string' && clientEnvVarsString.trim() !== '') {
      rawConfig = JSON.parse(clientEnvVarsString)
    } else if (Array.isArray(clientEnvVarsString)) {
      rawConfig = clientEnvVarsString
    }

    if (!Array.isArray(rawConfig) || rawConfig.length === 0) {
      return []
    }

    const firstConfig: any = rawConfig[0] || {}
    return firstConfig.imageryProcurementClients || []
  } catch (error) {
    console.error('[ConfigCat] Failed to parse client_env_Varaiblaes:', error)
    return []
  }
}

interface IArtifactExportRawSection {
  exportModal?: {
    shapefiles?: IArtifactExportShapefile[]
    folders?: IArtifactExportFolder[]
    formats?: IArtifactExportFormat[]
  }
}

export const parseArtifactExportConfig = (
  artifactExportString: ArtifactExportFlagValue
): { sections: IArtifactExportSection[] } => {
  try {
    let config: Record<string, IArtifactExportRawSection> | null = null

    if (typeof artifactExportString === 'string' && artifactExportString.trim() !== '') {
      config = JSON.parse(artifactExportString) as Record<string, IArtifactExportRawSection>
    } else if (typeof artifactExportString === 'object' && artifactExportString !== null) {
      config = artifactExportString as Record<string, IArtifactExportRawSection>
    }

    if (!config) {
      return { sections: [] }
    }

    const sections: IArtifactExportSection[] = []
    const configToIterate = config

    Object.keys(configToIterate).forEach((key) => {
      const section = configToIterate[key]
      if (section?.exportModal) {
        sections.push({
          id: key.toLowerCase(),
          displayName: key.toUpperCase(),
          shapefiles: section.exportModal.shapefiles ?? [],
          folders: section.exportModal.folders ?? [],
          formats: section.exportModal.formats ?? [],
        })
      }
    })

    return { sections }
  } catch (error) {
    console.error('[ConfigCat] Failed to parse artifact_export:', error)
    return { sections: [] }
  }
}

export const getActiveWorkflowFilterCount = (filters: {
  workflowStages: string[]
  workflowStatuses: string[]
  resourceVersions: number[]
  createdAtRange: [any, any]
  updatedAtRange: [any, any]
}): number => {
  let count = 0
  if (filters.workflowStages.length > 0) count++
  if (filters.workflowStatuses.length > 0) count++
  if (filters.resourceVersions.length > 0) count++
  if (filters.createdAtRange[0] || filters.createdAtRange[1]) count++
  if (filters.updatedAtRange[0] || filters.updatedAtRange[1]) count++
  return count
}

export const generateVersionOptions = (limit: number) => {
  return Array.from({ length: limit }, (_, i) => ({
    label: `v${i + 1}`,
    value: i + 1,
  }))
}

export { handleStringToObj, playAudioFile }
